import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from '@microsoft/signalr';

import { SIMADMIN_HUB_ENDPOINT, SOCKET_ERR_MSG } from '../constants';

class SignalRMiddleware {
  constructor(host, url) {
    if (!host) throw new Error(SOCKET_ERR_MSG);
    if (!url) throw new Error(SOCKET_ERR_MSG);
    this.hubUrl = `${host}${SIMADMIN_HUB_ENDPOINT}${url}`;
  }

  // Initialize web socket
  openSocket = () => {
    return new HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.Information)
      .build();
  };
}

export default SignalRMiddleware;
